import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ViewParams } from '../../models/ViewParams';
import { FormContextValue } from '../../contexts/FormContext';
import { WindowViewState } from '../models/state.model';

const initialState: WindowViewState = {
  viewParams: null,
};

const WindowViewSlice = createSlice({
  name: 'windowView',
  initialState,
  reducers: {
    openWindowView(
      state,
      action: PayloadAction<{
        viewParams: ViewParams;
        triggerRect?: { top: number; left: number; width: number; height: number };
      }>,
    ) {
      state.viewParams = action.payload.viewParams;
      state.context = []
      state.triggerRect = action.payload.triggerRect ?? null;

      delete state.dataRequest;
      delete state.context;
    },
    closeWindowView(state) {
      state.viewParams = null;
      state.triggerRect = null;
      delete state.dataRequest;
      delete state.context;
    },
    setWindowViewData(state, action: PayloadAction<ViewParams>) {
      if (state.viewParams) {
        state.dataRequest = action.payload;
      }
    },
    setWindowViewContext(state, action: PayloadAction<FormContextValue>) {
      if (state.viewParams) {
        if (!state.context) {
          state.context = [];
        }
        state.context.push(action.payload);
      }
    },
  },
});

export const { openWindowView, closeWindowView, setWindowViewData, setWindowViewContext } =
  WindowViewSlice.actions;

const WindowViewStateReducer = WindowViewSlice.reducer;
export default WindowViewStateReducer;
